import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Style, Stroke, Fill, Text } from 'ol/style.js';
import ApiService from 'services/ApiService';
import { setSourceForGeoJSON } from 'map/OlExtension';

export default class CommonBoundaryLayer extends VectorLayer {
    constructor(map, options) {
        super({
            name: 'boundary',
            style:
                options?.transparency ?
                    (feature) => this.styleFunctionTransparency(feature)
                    :
                    (feature) => this.styleFunctionDefault(feature)
        });
        this.map = map;
        this.setGeoJson();
    }

    setGeoJson = function () {
        const layer = this;
        ApiService.get("dashboard/Map/Boundary").then(response => {
            if (response.status === 200) {
                const data = response.data;
                setSourceForGeoJSON(layer, data)
            }
        })
    }

    styleFunctionDefault = (feature) => {
        const nm = feature.getProperties()['SIGUNGU_NM'];
        return new Style({
            stroke: new Stroke({
                color: 'rgba( 200, 200, 200, 0.7)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgb(33, 43, 54)'
            }),
            // text: new Text({
            //     font: "10px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
            //     scale: 2,
            //     text: nm.replace('수원시', '').trim(),
            //     fill: new Fill({ color: '#AAAAAA' }),
            //     //stroke: new Stroke({ color: 'gray', width: 1 })
            // })
        })
    };

    styleFunctionTransparency = (feature) => {
        const nm = feature.getProperties()['SIGUNGU_NM'];
        return new Style({
            stroke: new Stroke({
                color: 'rgba( 200, 200, 200, 0.3)',
                width: 6
            }),
            // text: new Text({
            //     font: "24px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
            //     scale: 2,
            //     text: nm.replace('수원시', '').trim(),
            //     fill: new Fill({ color: 'rgba( 200, 200, 200, 0.5)' }),
            //     //stroke: new Stroke({ color: 'gray', width: 1 })
            // })
        })
    };

    styleFunctionStorke = (feature) => {
        const nm = feature.getProperties()['SIGUNGU_NM'];
        return new Style({
            stroke: new Stroke({
                color: 'rgba( 200, 200, 200, 0.3)',
                width: 6
            }),
            text: new Text({
                font: "24px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                scale: 2,
                text: nm.replace('수원시', '').trim(),
                fill: new Fill({ color: 'rgba( 200, 200, 200, 0.5)' }),
                //stroke: new Stroke({ color: 'gray', width: 1 })
            })
        })
    };
}